@if (visible) {
  <div class="backdrop" (click)="onClosed()"></div>
  <div class="uppercase mobile__menu" id="mobile-cart-menu">
    @if (canSeeBuyingWindows) {
      <div class="menu__header fw-bold">Buying Window</div>
      @if (activeBWOrder) {
        <div class="menu__item">
          <span class="price">{{ activeBWOrder.totalCost | currency }}</span>
          <a
            id="mobile-cart-view-bw-order-link"
            routerLink=""
            class="link link-underline fw-bold"
            (click)="navigateToOrder(activeBWOrder)"
            >View Order</a
          >
        </div>
      }
      @if (!activeBWOrder) {
        <div class="menu__item">Order Empty</div>
      }
    }
    <div class="menu__header fw-bold">On Demand</div>
    @if (activeODOrder) {
      <div class="menu__item">
        <span class="price">{{ activeODOrder.totalCost | currency }}</span>
        <a
          id="mobile-cart-checkout-link"
          href="#"
          class="link link-underline fw-bold"
          (click)="navigateToOrder(activeODOrder)"
          >Checkout</a
        >
      </div>
    }
    @if (!activeODOrder) {
      <div class="menu__item">Order Empty</div>
    }
    <div
      class="menu__header mt-2"
      id="mobile-cart-view-all-orders"
      (click)="navigateToOrder()"
    >
      View all open orders
    </div>
  </div>
}
